import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Input,
  Button,
  Row,
  Col,
  Spinner,
  CardHeader,
  Alert
} from "reactstrap";
// import axios from "axios";
import api from "../../services/api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./invoice.css";

const PaymentReceipt = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [rollNo, setRollNo] = useState("");
  const [paymentsData, setPaymentsData] = useState([]);
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [user, setUser] = useState();

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    setUser(authUser);
  }, []);

  // Fetch student details + payments
  const handleFetchPaymentsData = async () => {
    if (!rollNo.trim()) {
      setErrorMsg("Please enter Roll No.");
      return;
    }

    setErrorMsg("");
    setLoading(true);
    setStudentData(null);
    setPaymentsData([]);

    try {
      const res = await api.post(`${backendUrl}get-student-payments-by-rollno`, {
        roll_no: rollNo.toUpperCase().trim(),
      });

      if (res.data.success && res.data.data.length > 0) {
        setPaymentsData(res.data.data);

        // Extract student details from first record
        const st = res.data.data[0];
        setStudentData({
          name: st.name,
          roll_no: st.roll_no,
          college: st.college,
          branch: st.branch,
          passout_year: st.passout_year
        });
      } else {
        setErrorMsg(res.data.message || "No student/payment records found.");
      }
    } catch (err) {
      setErrorMsg(err.response?.data?.message || "Something went wrong.");
    }

    setLoading(false);
  };

  // Format IST Date
  const formatISTDate = (isoDate) => {
    const options = {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(isoDate)
      .toLocaleString("en-IN", options)
      .replace(",", "")
      .replaceAll("/", "-");
  };

  // Generate Invoice PDF
  const generateInvoicePDF = async (p) => {
    console.log("Generating PDF for:", p);
    const invoiceDiv = document.createElement("div");
    invoiceDiv.className = "invoice-container";
    invoiceDiv.style.position = "absolute";
    invoiceDiv.style.left = "-9999px";

    invoiceDiv.innerHTML = `
    <div class="overlay">
      <h1 class="payment-id">No.${p.payment_id}</h1>
      <h1 class="payment-date">${p.payment_date}</h1>
      <h2 class="trainee-name">${p.trainee_name}</h2>
      <h2 class="trainee-roll-no">${p.trainee_roll_no}</h2>
      <h2 class="trainee-branch">${p.trainee_branch}</h2>
      <h2 class="trainee-passout">${p.trainee_passout_year}</h2>
      <h2 class="trainee-college">${p.trainee_college}</h2>
      <h2 class="name-of-the-track">${p.name_of_the_course}</h2>
      <h2 class="name-of-the-course">${p.name_of_the_track}</h2>
      <h2 class="amount-paid">${p.amount_paid}</h2>
      <h2 class="the-term">${p.the_term}</h2>
      <h2 class="cashier-name">${p.cashier_name}</h2>
    <h1 class="payment-id-1">No.${p.payment_id}</h1>
        <h1 class="payment-date-1 text-uppercase">${p.payment_date}</h1>
        <h2 class="trainee-name-1">${p.trainee_name}</h2>
        <h2 class="trainee-roll-no-1">${p.trainee_roll_no}</h2>
        <h2 class="trainee-branch-1">${p.trainee_branch}</h2>
        <h2 class="trainee-passout-1">${p.trainee_passout_year}</h2>
        <h2 class="trainee-college-1">${p.trainee_college}</h2>
        <h2 class="name-of-the-track-1">${p.name_of_the_course}</h2>
        <h2 class="name-of-the-course-1">${p.name_of_the_track}</h2>
        <h2 class="amount-paid-1">${p.amount_paid}</h2>
        <h2 class="the-term-1">${p.the_term}</h2>
        <h2 class="cashier-name-1">${p.cashier_name}</h2>
    </div>

  `;

    document.body.appendChild(invoiceDiv);

    const canvas = await html2canvas(invoiceDiv, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);

    // Instead of download, create Blob for preview
    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open PDF in new tab (user chooses Print or Download)
    window.open(pdfUrl, "_blank");

    document.body.removeChild(invoiceDiv);
  };


  console.log("paymentsData:", paymentsData);
  return (
    <div className="mt-4">

      {/* Search Card */}
      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
        <CardBody>
          <Row className="align-items-end g-3">
            <Col md={2}>
              <label className="fw-semibold">Roll Number</label>
              <Input
                type="text"
                value={rollNo}
                onChange={(e) => setRollNo(e.target.value)}
                placeholder="Enter Student Roll No"
                bsSize="md"
              />
            </Col>

            <Col md={2}>
              <Button
                color="primary"
                size="md"
                className="w-100 fw-semibold"
                disabled={loading}
                onClick={handleFetchPaymentsData}
              >
                {loading ? <Spinner size="sm" /> : "Get Payments"}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {errorMsg && (
        <Alert color="danger">{errorMsg}</Alert>
      )}


      {/* Student Details Card */}
      {studentData && (
        <Card className="shadow-sm border-0 mb-4 w-75" style={{ borderRadius: "12px" }}>
          <CardHeader
            className="bg-primary"
            style={{
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            Student Details
          </CardHeader>

          <CardBody style={{ padding: "25px" }}>
            <Row className="gy-3 fs-5">

              <Col md={3}>
                <div className="detail-label fw-bold">Name</div>
                <div className="detail-value">{studentData.name}</div>
              </Col>

              <Col md={2}>
                <div className="detail-label fw-bold">Roll Number</div>
                <div className="detail-value">{studentData.roll_no}</div>
              </Col>

              <Col md={2}>
                <div className="detail-label fw-bold">College</div>
                <div className="detail-value">{studentData.college}</div>
              </Col>

              <Col md={2}>
                <div className="detail-label fw-bold">Branch</div>
                <div className="detail-value">{studentData.branch}</div>
              </Col>

              <Col md={2}>
                <div className="detail-label fw-bold">Passout Year</div>
                <div className="detail-value">{studentData.passout_year}</div>
              </Col>

            </Row>
          </CardBody>
        </Card>
      )}

      {/* Payments Table */}
      {paymentsData.length > 0 && (
        <Card className="shadow-sm border-0" style={{ borderRadius: "12px" }}>
          <CardHeader
            className="bg-primary"
            style={{
              color: "white",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            Payment Receipts
          </CardHeader>

          <CardBody className="p-0">
            <table className="table table-hover mb-0 payment-table">
              <thead>
                <tr>
                  <th>Course</th>
                  <th>Technology</th>
                  <th>Payment ID</th>
                  <th>Term</th>
                  <th>Amount</th>
                  <th>Cashier</th>
                  <th>Counter</th>
                  <th>Date</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {paymentsData.map((ele, idx) => (
                  <tr key={idx}>
                    <td>{ele.course_name}</td>
                    <td>{ele.technology_name}</td>
                    <td><b>{ele.payment_id}</b></td>
                    <td>{ele.term_name}</td>
                    <td><b style={{ color: "#0c7c0c" }}>₹{ele.amount}</b></td>
                    <td>{ele.cashier_name}</td>
                    <td>{ele.cash_counter_name}</td>
                    <td>{formatISTDate(ele.payment_date)}</td>

                    <td className="text-center">
                      <Button
                        color="success"
                        size="sm"
                        style={{ fontWeight: "600" }}
                        onClick={() =>
                          generateInvoicePDF({
                            trainee_roll_no: ele.roll_no,
                            trainee_name: ele.name,
                            trainee_branch: ele.branch,
                            trainee_college: ele.college,
                            trainee_passout_year: ele.passout_year,
                            name_of_the_track: ele.course_name,
                            name_of_the_course: ele.technology_name,
                            amount_paid: ele.amount,
                            the_term: ele.term_name,
                            payment_id: ele.payment_id,
                            payment_date: formatISTDate(ele.payment_date),
                            cashier_name: ele.cashier_name,
                          })
                        }
                      >
                        View
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardBody>
        </Card>
      )}

    </div>
  );
};

export default PaymentReceipt;
